"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var keamiddleware_1 = require("./keamiddleware");
exports.keaResourceMiddleware = keamiddleware_1.keaResourceMiddleware;
const keautils_1 = require("keautils");
var httpRequest_1 = require("./httpRequest");
exports.httpRequest = httpRequest_1.httpRequest;
var statusErrorMiddleware_1 = require("./statusErrorMiddleware");
exports.statusErrorMiddleware = statusErrorMiddleware_1.statusErrorMiddleware;
class JsonMiddlewareError extends Error {
}
exports.JsonMiddlewareError = JsonMiddlewareError;
;
/**Reemplaza las fechas con una serialización ISO 8601 respetando la zona horaria original */
function stringifyReplacer(key, value) {
    if (value instanceof Date) {
        return keautils_1.toIsoDate(value);
    }
    return value;
}
/**Middleware que serializa el body y la respuesta de un request */
async function jsonMiddleware(req, next) {
    req = Object.assign(Object.assign({}, req), { headers: Object.assign(Object.assign({}, req.headers), { "Content-Type": "application/json;charset=UTF-8" }), body: JSON.stringify(req.body, stringifyReplacer) });
    const response = await next(req);
    const json = (() => {
        if (response) {
            try {
                return JSON.parse(response);
            }
            catch (ex) {
                throw new JsonMiddlewareError("Hubo un error al tratar de parsear el JSON de la respuesta HTTP: " + ex);
            }
        }
        else
            return undefined;
    })();
    return json;
}
exports.jsonMiddleware = jsonMiddleware;
/**Crea un middleware que pega una cadena antes de la url */
function createBaseUrlMiddleware(baseUrl) {
    return async function baseUrlMiddleware(req, next) {
        req = Object.assign(Object.assign({}, req), { url: baseUrl + req.url });
        return await next(req);
    };
}
exports.createBaseUrlMiddleware = createBaseUrlMiddleware;
function createAddHeaderMiddleware(getHeader) {
    /**Agrega el header de  Cache-Control:no-transform*/
    return async function cacheControlMiddleware(req, next) {
        const header = await getHeader(req);
        req = Object.assign(Object.assign({}, req), { headers: Object.assign(Object.assign({}, req.headers), { [header.name]: header.value }) });
        return await next(req);
    };
}
exports.createAddHeaderMiddleware = createAddHeaderMiddleware;
/**Agrega el header de  Cache-Control:no-transform*/
exports.cacheControlMiddleware = createAddHeaderMiddleware(async () => ({ name: "Cache-Control", value: "no-transform" }));
/**Devuelve un middleware que establece el header "Authorization" de la sesión */
function createSessionMiddleware(getSession) {
    return createAddHeaderMiddleware(async () => ({ name: "Authorization", value: await getSession() }));
}
exports.createSessionMiddleware = createSessionMiddleware;
/**
 * Compone una cadena de middlewares. Normalmente el ultimo middleware es el httpRequest
 * @param middlewares Middlewares que se quieren componer
 */
function composeMiddlewares(middlewares) {
    return async function (req, next) {
        const chain = middlewares.reduceRight((prev, curr) => async (req) => {
            return await curr(req, prev);
        }, next);
        return await chain(req);
    };
}
exports.composeMiddlewares = composeMiddlewares;
//# sourceMappingURL=middlewares.js.map


//////////////////
// WEBPACK FOOTER
// ./~/kea-resource/dist/http/middlewares.js
// module id = 2269
// module chunks = 0